<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="520px"
    scrollable
    transition="scroll-y-transition"
  >
    <cookie-dialog-card
      :cookies="cookies"
      :cookie-groups="cookieGroups"
      @save="save"
      @click:allowed-all="allowedAll"
    ></cookie-dialog-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api'
import CookieDialogCard from '~/components/cookie/CookieDialogCard'
import { INTERCEPTOR_KEYS, useIntercept } from '~/composables'

export default {
  name: 'CookieManagerDialog',
  components: {
    CookieDialogCard,
  },
  setup(_, { root }) {
    const { intercept } = useIntercept(root)
    const dialog = ref(false)

    intercept(INTERCEPTOR_KEYS.COOKIE_OPEN_DIALOG, () => {
      dialog.value = true
    })

    return {
      dialog,
    }
  },
  data() {
    return {
      cookies: [],
      cookieGroups: [],
    }
  },
  mounted() {
    this.cookies = this.$ccm.getCookies()
    this.cookieGroups = this.$ccm.getCookieGroups()
    this.dialog = this.$ccm.shouldShowConsent
  },
  methods: {
    save(values) {
      this.$ccm.saveCookies(values)

      this.dialog = false
    },
    allowedAll() {
      this.$ccm.allowedAll()

      this.dialog = false
    },
  },
}
</script>
